export default __webpack_public_path__ + "static/media/impact_investing-lt.90eb07e2.png";